<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Form :model="formItem" :rules="ruleValidate" :label-width="105" label-position="right"
                          ref="form">
                        <Row>
                            <Col>
                                <FormItem :label="t.dict.label" prop="label">
                                    <Input v-model="formItem.label" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.dict.label)"></Input>
                                </FormItem>
                                <FormItem :label="t.dict.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.dict.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.dict.open}}</span>
                                        <span slot="close">{{t.dict.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem :label="t.dict.category" prop="category">
                                    <Input v-model="formItem.category" readonly=""></Input>
                                </FormItem>
                                <transition name="fade" mode="out-in">
                                    <div>
                                        <FormItem :label="labelItem.data1" prop="data1" v-if="showFieldFlg(0)">
                                            <Input v-model="formItem.data1"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data1)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(0,formItem.data1)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data2" prop="data2" v-if="showFieldFlg(1)">
                                            <Input v-model="formItem.data2"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data2)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(1,formItem.data2)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data3" prop="data3" v-if="showFieldFlg(2)">
                                            <Input v-model="formItem.data3"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data3)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(2,formItem.data3)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data4" prop="data4" v-if="showFieldFlg(3)">
                                            <Input v-model="formItem.data4"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data4)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(3,formItem.data4)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data5" prop="data5" v-if="showFieldFlg(4)">
                                            <Input v-model="formItem.data5"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data5)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(4,formItem.data5)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data6" prop="data6" v-if="showFieldFlg(5)">
                                            <Input v-model="formItem.data6"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data6)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(5,formItem.data6)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data7" prop="data7" v-if="showFieldFlg(6)">
                                            <Input v-model="formItem.data7"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data7)" readonly>
                                                <Button slot="append" type="success" :maxlength="100"
                                                        @click="openImageModal(6,formItem.data7)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data8" prop="data8" v-if="showFieldFlg(7)">
                                            <Input v-model="formItem.data8" :maxlength="100"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data8)" readonly>
                                                <Button slot="append" type="success"
                                                        @click="openImageModal(7,formItem.data8)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data9" prop="data9" v-if="showFieldFlg(8)">
                                            <Input v-model="formItem.data9" :maxlength="100"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data9)" readonly>
                                                <Button slot="append" type="success"
                                                        @click="openImageModal(8,formItem.data9)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="labelItem.data10" prop="data10" v-if="showFieldFlg(9)">
                                            <Input v-model="formItem.data10" :maxlength="100"
                                                   :placeholder="msgUtil.placeholderRequired(labelItem.data10)"
                                                   readonly>
                                                <Button slot="append" type="success"
                                                        @click="openImageModal(9,formItem.data10)">
                                                    {{msgUtil.message.action.picSelect}}
                                                </Button>
                                            </Input>
                                        </FormItem>
                                        <FormItem :label="t.dict.body" v-if="showFieldFlg(10)">
                                            <tinymce id="id1" v-model="formItem.body" :toolbar1="toolbar1"
                                                     :other_options="other_options"></tinymce>
                                        </FormItem>
                                    </div>
                                </transition>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="8">
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Col>
                            <Col span="16">
                                <span v-if="showFieldFlg(step-1)" v-for="step in 10" :key="step" style="float: right;">
                                    <div class="dist-upload-list" v-if="fieldExistsFlg(step-1) != null">
                                        <img :src="fieldExistsFlg(step-1)"/>
                                        <div class="dist-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal(step-1)"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                </span>
                                <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                    <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                    <div slot="footer">
                                        {{previewImageName}}
                                    </div>
                                </Modal>
                            </Col>
                        </Row>
                    </Form>
                </Row>
            </Card>
        </Row>
        <Modal
            :title='msgUtil.message.action.changePic'
            v-model="imageModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            :width="imageModalWidth">
            <Row>
                <div class="sub-cropper">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.outputSize"
                        :outputType="option.outputType"
                        :info="option.info"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :fixedBox="option.fixedBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :centerBox="option.centerBox"
                        :high="option.high"
                        :infoTrue="option.infoTrue"
                        @realTime="realTime"
                        @imgLoad="imgLoad"
                        @cropMoving="cropMoving"
                        :enlarge="option.enlarge"
                    ></vueCropper>
                </div>
            </Row>
            <Row>
                <Col style="text-align:right;">
                    <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                            style="display:inline-block;margin-right: 10px;">
                        <Button icon="ios-cloud-upload-outline">
                            {{msgUtil.message.action.picSelect}}
                        </Button>
                    </Upload>
                    <Button v-if="option.img != null && option.img !== ''" type="primary" @click="handleUpload">
                        {{msgUtil.message.action.upload}}
                    </Button>
                    <Button v-else type="primary" disabled>
                        {{msgUtil.message.action.upload}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import axios from 'axios';
import { edit, getDictInfo } from '@/api/dict';
import { getConfigInfo } from '@/api/config';
import { VueCropper } from 'vue-cropper';
import { uploadImg } from '@/api/image';

export default {
    name: 'content_dict_edit',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            option: {
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 0,
                autoCropHeight: 0,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            imageModal: false,
            imageSizeList: [],
            currentConfigInfoValIndex: -1,
            currentConfigInfo: null,
            previewImageModal: false,
            previewImage: null,
            previewImageWidth: 0,
            previewImageName: '',
            labelItem: {
                data1: t.dict.data1,
                data2: t.dict.data2,
                data3: t.dict.data3,
                data4: t.dict.data4,
                data5: t.dict.data5,
                data6: t.dict.data6,
                data7: t.dict.data7,
                data8: t.dict.data8,
                data9: t.dict.data9,
                data10: t.dict.data10,
            },
            formItemBk: {},
            formItem: {
                configId: '',
                sortOrder: 0,
                label: '',
                data1: null,
                data2: null,
                data3: null,
                data4: null,
                data5: null,
                data6: null,
                data7: null,
                data8: null,
                data9: null,
                data10: null,
                status: '1',
                body: '',
                category: '',
            },
            ruleValidate: {
                label: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.label),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 50,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.label, 50),
                        trigger: 'blur',
                    },
                ],
                data1: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data1, 100),
                        trigger: 'blur',
                    },
                ],
                data2: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data2, 100),
                        trigger: 'blur',
                    },
                ],
                data3: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data3, 100),
                        trigger: 'blur',
                    },
                ],
                data4: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data4, 100),
                        trigger: 'blur',
                    },
                ],
                data5: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data5, 100),
                        trigger: 'blur',
                    },
                ],
                data6: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data1),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data6, 100),
                        trigger: 'blur',
                    },
                ],
                data7: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data7),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data7, 100),
                        trigger: 'blur',
                    },
                ],
                data8: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data8),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data8, 100),
                        trigger: 'blur',
                    },
                ],
                data9: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data9),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data9, 100),
                        trigger: 'blur',
                    },
                ],
                data10: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dict.data10),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.dict.data10, 100),
                        trigger: 'blur',
                    },
                ],
            },
            toolbar1:
                'newnote print preview code | undo redo | insert | styleselect | fontsizeselect | fontselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons media codesample',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
                images_upload_handler: function (blobInfo, success, failure) {
                    let param = new FormData(); //创建form对象
                    param.append('image', blobInfo.blob(), blobInfo.filename()); //通过append向form对象添加数据
                    axios
                        .post(BaseUrl.dataUrl + '/image/scale/', param)
                        .then(response => success(BaseUrl.Url + response.data.url));
                },
            },
            loading: false,
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    computed: {
        imageModalWidth() {
            let width = this.option.autoCropWidth + 100;
            return width < 600 ? 600 : width;
        },
        previewImageModalWidth() {
            return this.previewImageWidth;
        },
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            if (await this.$refs['form'].validate()) {
                let dictDto = {};
                dictDto.configId = this.formItem.configId;
                dictDto.label = this.formItem.label;
                dictDto.sortOrder = this.formItem.sortOrder;
                dictDto.status = this.formItem.status;
                dictDto.data1 = this.formItem.data1;
                dictDto.data2 = this.formItem.data2;
                dictDto.data3 = this.formItem.data3;
                dictDto.data4 = this.formItem.data4;
                dictDto.data5 = this.formItem.data5;
                dictDto.data6 = this.formItem.data6;
                dictDto.data7 = this.formItem.data7;
                dictDto.data8 = this.formItem.data8;
                dictDto.data9 = this.formItem.data9;
                dictDto.data10 = this.formItem.data10;
                dictDto.body = this.formItem.body;
                await edit(this.$route.params.id, dictDto);
                dictDto.category = this.formItem.category;
                Object.assign(this.formItemBk, dictDto);
                this.$Loading.finish();
                this.$Message.success(this.msgUtil.message.action.updateSuccess);
                this.handleReset();
            } else {
                this.$Loading.error();
                this.$Message.error(this.msgUtil.message.action.updateFail);
            }
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.$refs.cropper.clearCrop();
            Object.assign(this.formItem, this.formItemBk);
            this.option.img = null;
            this.loading = false;
        },
        //data1-data7属性存在的判定
        fieldExistsFlg(index) {
            if (index === 0) {
                return this.formItem.data1;
            } else if (index === 1) {
                return this.formItem.data2;
            } else if (index === 2) {
                return this.formItem.data3;
            } else if (index === 3) {
                return this.formItem.data4;
            } else if (index === 4) {
                return this.formItem.data5;
            } else if (index === 5) {
                return this.formItem.data6;
            } else if (index === 6) {
                return this.formItem.data7;
            } else if (index === 7) {
                return this.formItem.data8;
            } else if (index === 8) {
                return this.formItem.data9;
            } else if (index === 9) {
                return this.formItem.data10;
            }
        },
        //data1-data7和body默认表示爹判定逻辑
        showFieldFlg(index) {
            const configInfo = this.currentConfigInfo;
            if (configInfo == null) {
                return false;
            }
            if (index === 0) {
                return configInfo.value1 != null;
            } else if (index === 1) {
                return configInfo.value2 != null;
            } else if (index === 2) {
                return configInfo.value3 != null;
            } else if (index === 3) {
                return configInfo.value4 != null;
            } else if (index === 4) {
                return configInfo.value5 != null;
            } else if (index === 5) {
                return configInfo.value6 != null;
            } else if (index === 6) {
                return configInfo.value7 != null;
            } else if (index === 7) {
                return configInfo.value8 != null;
            } else if (index === 8) {
                return configInfo.value9 != null;
            } else if (index === 9) {
                return configInfo.value10 != null;
            } else if (index === 10) {
                return configInfo.type === '1';
            }
            return false;
        },
        //图片预览
        openPreviewImageModal(index) {
            let size = 0;
            if (index === 0) {
                this.previewImage = this.formItem.data1;
                size = this.currentConfigInfo.value1;
                this.previewImageName = this.labelItem.data1;
            } else if (index === 1) {
                this.previewImage = this.formItem.data2;
                size = this.currentConfigInfo.value2;
                this.previewImageName = this.labelItem.data2;
            } else if (index === 2) {
                this.previewImage = this.formItem.data3;
                size = this.currentConfigInfo.value3;
                this.previewImageName = this.labelItem.data3;
            } else if (index === 3) {
                this.previewImage = this.formItem.data4;
                size = this.currentConfigInfo.value4;
                this.previewImageName = this.labelItem.data4;
            } else if (index === 4) {
                this.previewImage = this.formItem.data5;
                size = this.currentConfigInfo.value5;
                this.previewImageName = this.labelItem.data5;
            } else if (index === 5) {
                this.previewImage = this.formItem.data6;
                size = this.currentConfigInfo.value6;
                this.previewImageName = this.labelItem.data6;
            } else if (index === 6) {
                this.previewImage = this.formItem.data7;
                size = this.currentConfigInfo.value7;
                this.previewImageName = this.labelItem.data7;
            } else if (index === 7) {
                this.previewImage = this.formItem.data8;
                size = this.currentConfigInfo.value8;
                this.previewImageName = this.labelItem.data8;
            } else if (index === 8) {
                this.previewImage = this.formItem.data9;
                size = this.currentConfigInfo.value9;
                this.previewImageName = this.labelItem.data9;
            } else if (index === 9) {
                this.previewImage = this.formItem.data10;
                size = this.currentConfigInfo.value10;
                this.previewImageName = this.labelItem.data10;
            }
            let width = parseInt(size.split('x')[0]) + 32;
            this.previewImageWidth = width < 100 ? 105 : width;
            this.previewImageModal = true;
        },

        //图片裁剪
        openImageModal(index, url) {
            const configInfo = this.currentConfigInfo;
            this.currentConfigInfoValIndex = index;
            let size = '0';
            if (index === 0) {
                size = configInfo.value1;
            } else if (index === 1) {
                size = configInfo.value2;
            } else if (index === 2) {
                size = configInfo.value3;
            } else if (index === 3) {
                size = configInfo.value4;
            } else if (index === 4) {
                size = configInfo.value5;
            } else if (index === 5) {
                size = configInfo.value6;
            } else if (index === 6) {
                size = configInfo.value7;
            } else if (index === 7) {
                size = configInfo.value8;
            } else if (index === 8) {
                size = configInfo.value9;
            } else if (index === 9) {
                size = configInfo.value10;
            }
            if (size != null && size !== '0') {
                let arr = size.split('x');
                this.option.autoCropWidth = parseInt(arr[0]);
                this.option.autoCropHeight = parseInt(arr[1]);
                this.$refs.cropper.changeCrop(this.option.autoCropWidth, this.option.autoCropHeight);
                this.option.img = url;
                this.imageModal = true;
            }
        },
        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }
            const reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        // 实时预览函数
        realTime(data) {
            //console.log(data);
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    let index = this.currentConfigInfoValIndex;
                    let fullUrl = BaseUrl.Url + d.url;
                    if (index === 0) {
                        this.formItem.data1 = fullUrl;
                    } else if (index === 1) {
                        this.formItem.data2 = fullUrl;
                    } else if (index === 2) {
                        this.formItem.data3 = fullUrl;
                    } else if (index === 3) {
                        this.formItem.data4 = fullUrl;
                    } else if (index === 4) {
                        this.formItem.data5 = fullUrl;
                    } else if (index === 5) {
                        this.formItem.data6 = fullUrl;
                    } else if (index === 6) {
                        this.formItem.data7 = fullUrl;
                    } else if (index === 7) {
                        this.formItem.data8 = fullUrl;
                    } else if (index === 8) {
                        this.formItem.data9 = fullUrl;
                    } else if (index === 9) {
                        this.formItem.data10 = fullUrl;
                    }
                    this.imageModal = false;
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
    },
    async mounted() {
        //得到字典情报
        const dictInfo = await getDictInfo(this.$route.params.id);
        if (dictInfo.dict != null) {
            this.formItem = dictInfo.dict;
            const configInfo = await getConfigInfo(dictInfo.dict.configId);
            if (configInfo.config != null) {
                this.currentConfigInfo = configInfo.config;
                this.formItem.category = this.currentConfigInfo.name;
                //动态设定标签名称
                this.labelItem.data1 = this.currentConfigInfo.key1;
                this.labelItem.data2 = this.currentConfigInfo.key2;
                this.labelItem.data3 = this.currentConfigInfo.key3;
                this.labelItem.data4 = this.currentConfigInfo.key4;
                this.labelItem.data5 = this.currentConfigInfo.key5;
                this.labelItem.data6 = this.currentConfigInfo.key6;
                this.labelItem.data7 = this.currentConfigInfo.key7;
                this.labelItem.data8 = this.currentConfigInfo.key8;
                this.labelItem.data9 = this.currentConfigInfo.key9;
                this.labelItem.data10 = this.currentConfigInfo.key10;
            }
            Object.assign(this.formItemBk, this.formItem);
        }
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.dist-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.dist-upload-list img {
    width: 100%;
    height: 100%;
}

.dist-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.dist-upload-list:hover .dist-upload-list-cover {
    display: block;
}

.dist-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
